var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    _vm.btnClass,
    'preika-save-button',
    ("preika-save-button--" + _vm.resolvedActionKind)
  ],attrs:{"type":"button","data-action-kind":_vm.resolvedActionKind,"disabled":_vm.loading || _vm.disabled,"aria-busy":_vm.loading ? 'true' : 'false',"aria-label":_vm.displayLabel},on:{"click":function($event){return _vm.$emit('click', $event)}}},[(_vm.loading)?_c('span',{staticClass:"my-spinner",attrs:{"aria-hidden":"true"}}):_vm._e(),_c('span',{staticClass:"preika-save-button__label"},[_vm._v(_vm._s(_vm.displayLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }